export default {
  Document: 'document',
};
